import { useContext } from 'react';
import { SetupSubdomainModalContext } from './SetupSubdomainModalContext';

const useSetupSubdomainModal = () => {
  return useContext(SetupSubdomainModalContext);
};

export default useSetupSubdomainModal;
